'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Bacon, Dispatcher, MIN_DISTANCE_FOR_CURRENT, R, addAddressCityFilter, addAddressFilter, addChannelFilter, addCuisinesFilter, addDefaultFilters, addDefaultSorting, addESQueryFilterMust, addESQueryFilterMustNot, addESQueryFilterShould, addESQuerySort, addLocationFilter, addNoTagsFilter, addServiceFilter, addServiceTimeFilter, addTagsFilter, addTimeFilter, address, addressToLocation, channel, createQuery, cuisines, d, distance, distanceFilter, distanceSort, fieldFilter, intersectFilter, loader, location, moment, notags, resUtil, restaurantGqlStore, results, service, sortByDistance, tags, termFilter, termsFilter, time, total, validateParams;

Bacon = require('baconjs');

R = require('ramda');

resUtil = require('../utils/resources');

moment = require('moment');

Dispatcher = require('../utils/dispatcher');

d = new Dispatcher("portal");

restaurantGqlStore = require('./restaurants-gql');

MIN_DISTANCE_FOR_CURRENT = 15;

// Address -> Location
addressToLocation = function addressToLocation(address) {
  return {
    lng: address.position.longitude,
    lat: address.position.latitude
  };
};

// returns an object of *** type { field: { term: value } } ***
// Field -> Term -> Value -> ESQueryFilterExpr
fieldFilter = R.curry(function (field, term, value) {
  return R.assoc(field, R.assoc(term, value, {}), {});
});

// Term -> Value -> ESQueryFilterExpr
termFilter = fieldFilter('term');

termsFilter = fieldFilter('terms');

// Position -> ESQueryFilterExpr
intersectFilter = function intersectFilter(_ref) {
  var lat = _ref.lat,
      lng = _ref.lng;

  return {
    geo_shape: {
      "rules.shape": {
        shape: {
          coordinates: [lng, lat],
          type: "point"
        },
        relation: "intersects"
      }
    }
  };
};

// Position -> distance -> ESQueryFilterExpr
distanceFilter = function distanceFilter(_ref2) {
  var lat = _ref2.lat,
      lng = _ref2.lng;
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  return {
    geo_distance: {
      distance: distance + 'mi',
      position: {
        lat: lat,
        lon: lng
      }
    }
  };
};

// Position -> ESQuerySortExpr
distanceSort = function distanceSort(_ref3) {
  var lat = _ref3.lat,
      lng = _ref3.lng;

  return {
    _geo_distance: {
      unit: "mi",
      order: "asc",
      position: [lng, lat]
    }
  };
};

// params -> ESQuery
createQuery = function createQuery(params) {
  var esQuery;
  esQuery = {
    from: 0,
    size: 100,
    filter: {
      bool: {
        should: [],
        must: [],
        must_not: [],
        filter: []
      }
    },
    sort: [],
    query: {
      match_all: {}
    }
  };
  return {
    params: params,
    esQuery: esQuery,
    url: null
  };
};

// ESQuery -> ESQueryFilterExpr -> ESQuery
addESQueryFilterMust = function addESQueryFilterMust(esQuery, expr) {
  esQuery.filter.bool.must.push(expr);
  return esQuery;
};

addESQueryFilterMustNot = function addESQueryFilterMustNot(esQuery, expr) {
  esQuery.filter.bool.must_not.push(expr);
  return esQuery;
};

// ESQuery -> ESQueryFilterExpr -> ESQuery
addESQueryFilterShould = function addESQueryFilterShould(esQuery, expr) {
  esQuery.filter.bool.should.push(expr);
  return esQuery;
};

// ESQuery -> ESQuerySortExpr -> ESQuery
addESQuerySort = function addESQuerySort(esQuery, expr) {
  esQuery.sort.push(expr);
  return esQuery;
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addChannelFilter = function addChannelFilter(_ref4) {
  var params = _ref4.params,
      esQuery = _ref4.esQuery;

  var url;
  url = 'http://api.zuppler.com/v4/channels/' + params.channel.permalink + '/restaurants/search.json';
  return { params: params, esQuery: esQuery, url: url };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addServiceFilter = function addServiceFilter(_ref5) {
  var params = _ref5.params,
      esQuery = _ref5.esQuery,
      url = _ref5.url;

  var term;
  term = function () {
    switch (params.service) {
      case 'DELIVERY':
        return termFilter("configuration.accept_delivery", true);
      case 'PICKUP':
        return termFilter("configuration.accept_pickup", true);
      case 'DINEIN':
        return termFilter("configuration.accept_dinein", true);
      case 'CURBSIDE':
        return termFilter("configuration.accept_curbside", true);
    }
  }();
  return {
    params: params,
    url: url,
    esQuery: addESQueryFilterMust(esQuery, term)
  };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addTimeFilter = function addTimeFilter(_ref6) {
  var params = _ref6.params,
      esQuery = _ref6.esQuery,
      url = _ref6.url;

  var day, offset, orderTime, startLTTime, stopGTTime;
  if (params.time && params.service !== 'DELIVERY' && params.service !== 'PICKUP') {
    orderTime = moment(params.time);
    day = orderTime.day();
    offset = orderTime.hour() * 60 + orderTime.minutes();
    startLTTime = {
      range: _defineProperty({}, 'hours.day' + day + '.start', {
        lte: offset
      })
    };
    stopGTTime = {
      range: _defineProperty({}, 'hours.day' + day + '.stop', {
        gte: offset
      })
    };
    esQuery = R.reduce(addESQueryFilterMust, esQuery, [startLTTime, stopGTTime]);
  }
  return { params: params, esQuery: esQuery, url: url };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addServiceTimeFilter = function addServiceTimeFilter(_ref7) {
  var params = _ref7.params,
      esQuery = _ref7.esQuery,
      url = _ref7.url;

  var day, offset, orderTime, serviceId, startLTTime, stopGTTime;
  if (params.time && (params.service === 'DELIVERY' || params.service === 'PICKUP')) {
    orderTime = moment(params.time);
    day = orderTime.day();
    offset = orderTime.hour() * 60 + orderTime.minutes();
    serviceId = params.service.toLowerCase();
    startLTTime = {
      range: _defineProperty({}, serviceId + '_hours.day' + day + '.start', {
        lte: offset
      })
    };
    stopGTTime = {
      range: _defineProperty({}, serviceId + '_hours.day' + day + '.stop', {
        gte: offset
      })
    };
    esQuery = R.reduce(addESQueryFilterMust, esQuery, [startLTTime, stopGTTime]);
  }
  return { params: params, esQuery: esQuery, url: url };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addLocationFilter = function addLocationFilter(_ref8) {
  var params = _ref8.params,
      esQuery = _ref8.esQuery,
      url = _ref8.url;

  if (params.service !== 'DELIVERY') {
    esQuery = addESQueryFilterMust(esQuery, distanceFilter(params.location.location));
  }
  return { params: params, esQuery: esQuery, url: url };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addAddressFilter = function addAddressFilter(_ref9) {
  var params = _ref9.params,
      esQuery = _ref9.esQuery,
      url = _ref9.url;

  if (params.service === 'DELIVERY' && params.address) {
    esQuery = addESQueryFilterShould(esQuery, intersectFilter(addressToLocation(params.address)));
  }
  return { params: params, esQuery: esQuery, url: url };
};

addAddressCityFilter = function addAddressCityFilter(_ref10) {
  var params = _ref10.params,
      esQuery = _ref10.esQuery,
      url = _ref10.url;

  if (params.service === 'DELIVERY' && params.address && params.address.city) {
    esQuery = addESQueryFilterShould(esQuery, termFilter("rules.city_str", params.address.city.toLowerCase()));
  }
  return { params: params, esQuery: esQuery, url: url };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addCuisinesFilter = function addCuisinesFilter(_ref11) {
  var params = _ref11.params,
      esQuery = _ref11.esQuery,
      url = _ref11.url;

  if (params.cuisines && params.cuisines.length) {
    esQuery = addESQueryFilterMust(esQuery, fieldFilter("terms", "cuisines", params.cuisines));
  }
  return { params: params, esQuery: esQuery, url: url };
};

addTagsFilter = function addTagsFilter(_ref12) {
  var params = _ref12.params,
      esQuery = _ref12.esQuery,
      url = _ref12.url;

  if (params.tags && params.tags.length) {
    esQuery = addESQueryFilterMust(esQuery, termsFilter("tags", params.tags));
  }
  return { params: params, esQuery: esQuery, url: url };
};

addNoTagsFilter = function addNoTagsFilter(_ref13) {
  var params = _ref13.params,
      esQuery = _ref13.esQuery,
      url = _ref13.url;

  if (params.notags && params.notags.length) {
    esQuery = addESQueryFilterMustNot(esQuery, termsFilter("tags", params.notags));
  }
  return { params: params, esQuery: esQuery, url: url };
};

// Always add this last
// { params, ESQuery, URL } -> { params, ESQuery, URL }
sortByDistance = function sortByDistance(_ref14) {
  var params = _ref14.params,
      esQuery = _ref14.esQuery,
      url = _ref14.url;

  if (params.service === 'DELIVERY') {
    esQuery = addESQuerySort(esQuery, distanceSort(addressToLocation(params.address)));
  } else {
    esQuery = addESQuerySort(esQuery, distanceSort(params.location.location));
  }
  return { params: params, esQuery: esQuery, url: url };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addDefaultFilters = function addDefaultFilters(_ref15) {
  var params = _ref15.params,
      esQuery = _ref15.esQuery,
      url = _ref15.url;

  esQuery = R.reduce(addESQueryFilterMust, esQuery, [termFilter("state", "published"), termFilter("platform", "3.0"), termFilter("online_ordering_paused", false)]);
  return { params: params, esQuery: esQuery, url: url };
};

// { params, ESQuery, URL } -> { params, ESQuery, URL }
addDefaultSorting = function addDefaultSorting(_ref16) {
  var params = _ref16.params,
      esQuery = _ref16.esQuery,
      url = _ref16.url;

  // { params, esQuery: addESQuerySort(esQuery, fieldFilter("featured", "order", "desc")), url }
  return { params: params, esQuery: esQuery, url: url };
};

// params -> bool
validateParams = function validateParams(params) {
  return params.channel && (params.service === 'DELIVERY' && params.address || params.service === 'PICKUP' && params.location); //and params.time
};

channel = d.stream('channel-url').skipDuplicates().flatMap(resUtil.loadResourceFromURL).map(R.prop('channel')).toProperty();

service = new Bacon.Bus();

time = new Bacon.Bus();

location = new Bacon.Bus();

address = new Bacon.Bus();

cuisines = new Bacon.Bus();

distance = new Bacon.Bus();

tags = new Bacon.Bus();

notags = new Bacon.Bus();

loader = Bacon.combineTemplate({
  channel: channel,
  service: service,
  time: time,
  location: location,
  address: address,
  cuisines: cuisines,
  tags: tags,
  notags: notags
  // distance: distance
}).filter(validateParams).throttle(300).map(R.compose(sortByDistance, addChannelFilter, addTimeFilter, addServiceTimeFilter, addLocationFilter, addAddressFilter, addAddressCityFilter, addCuisinesFilter, addServiceFilter, addTagsFilter, addNoTagsFilter, addDefaultSorting, addDefaultFilters, createQuery)).flatMap(function (_ref17) {
  var params = _ref17.params,
      esQuery = _ref17.esQuery,
      url = _ref17.url;
  // allow setting all streams first
  return Bacon.retry({
    source: function source() {
      return resUtil.createResource({
        url: url,
        query: JSON.stringify(esQuery)
      });
    },
    retries: 5,
    isRetriable: R.always(true),
    delay: R.always(100)
  });
});

results = loader.map(R.prop('restaurants'));

total = loader.map(R.prop('total'));

module.exports = {
  total: total,
  restaurants: results,
  channel: channel,
  // setCurrent: (result) -> d.stream('current-result').push result
  // currentRestaurant: d.stream('current-result')
  current: Bacon.never(),
  loading: results.awaiting(loader),
  initChannelFromURL: function initChannelFromURL(url) {
    return d.stream('channel-url').push(url);
  },
  search: function search(_service, _address, _location, _time) {
    var _cuisines = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    var _tags = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

    var _exclude_tags = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

    service.push(_service);
    address.push(_address);
    location.push(_location);
    time.push(_time);
    cuisines.push(_cuisines);
    if (_tags) {
      tags.push(_tags);
    }
    if (_exclude_tags) {
      return notags.push(_exclude_tags);
    }
  }
};